import React, { useState } from "react";
import { logo, background } from "../../assets";
import axios from "../../library/axios";
import { MySwal } from "../../library/swal";
import { IconLogin } from "@tabler/icons-react";
import { APP_VERSION } from "../../constants/appVersion";
import { setHrefWithSlugHook } from "../../../src/config/routes/guards/slug";
import { getHospitalTokenKey } from "../../helpers/hospitalAuth";
import { VersionInfoButton } from "../../components";
import { getApiErrorMessage } from '../../helpers/apiErrorMessage';

const resolveLandingPath = (groupName) => {
  const normalized = String(groupName || "").trim().toLowerCase();
  if (normalized.includes("surveior internal")) {
    return "/dashboard-internal";
  }
  if (normalized.includes("surveior external")) {
    return "/dashboard-surveyor-external";
  }
  if (normalized.includes("kelompok kerja") || normalized.includes("pokja")) {
    return "/dashboard-pokja";
  }
  return "";
};

const LoginPage = () => {
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [username, setusername] = useState("");
  const [password, setpassword] = useState("");

  const [showModal, setShowModal] = useState(false);
  const [resetUsername, setResetUsername] = useState("");
  const [loadingReset, setLoadingReset] = useState(false);

  const handleResetPassword = () => {
    if (!resetUsername) {
      MySwal.fire({
        icon: "warning",
        title: "Oops!",
        text: "Username wajib diisi",
      });
      return;
    }

    setLoadingReset(true);

    axios({
      url: "/users/reset-pass",
      method: "POST",
      data: {
        username: resetUsername,
      },
    })
      .then((res) => {
        MySwal.fire({
          icon: "success",
          title: "Berhasil!",
          text: "Password berhasil direset ke Qwerty123#",
        });

        setShowModal(false);
        setResetUsername("");
        setLoadingReset(false);
      })
      .catch((err) => {
        setLoadingReset(false);
        MySwal.fire({
          icon: "error",
          title: "Error!",
          text: getApiErrorMessage(err, "Terjadi kesalahan"),
        });
      });
  };

  const handleLogin = () => {
    setLoading(true);
    setDisabled(true);
    const requestBody = {
      username: username,
      password: password,
    };

    axios({
      url: "/users/auth",
      method: "POST",
      data: requestBody,
    })
      .then((res) => {
        // console.log(res)
        // return false
        if (res.status === 200) {
          const token = res?.data?.token;
          if (token) {
            localStorage.setItem(getHospitalTokenKey(), token);
          }

          MySwal.fire({
            icon: "success",
            title: "Berhasil Login!",
            text: "Mengalihkan ke dashboard...",
          }).then(() => {
            setHrefWithSlugHook(resolveLandingPath(res?.data?.groupName));
          });

          setLoading(false);
          setDisabled(false);
        }
      })
      .catch((err) => {
        setLoading(false);
        setDisabled(false);
        if (err !== "") {
          console.log(err?.response?.data?.message);
          MySwal.fire({
            icon: "error",
            title: "Oops, Error!",
            text: getApiErrorMessage(err),
          });
        }
      });
  };

  return (
    <>
      <div className="container-fluid vh-100">
        <div className="row h-100">
          <div className="col-md-6 d-flex align-items-center justify-content-center">
            {/*begin::Wrapper*/}
            <div className="d-flex flex-column position-xl-fixed top-2 bottom-2 w-xl-600px">
              {/*begin::Content*/}
              <div className="d-flex flex-row-fluid flex-column text-center p-10 pt-lg-20">
                {/*begin::Logo*/}
                <img
                  alt="Logo"
                  src={logo}
                  className="img-fluid mb-10 mx-auto" // tambahkan mx-auto
                  style={{
                    width: '400px',
                    height: 'auto',
                  }}
                />
                {/*end::Logo*/}
                {/*begin::Title*/}
                <h1
                  className="fw-bolder fs-3qx pb-5 pb-md-4"
                  style={{ color: '#26196b' }}
                >
                  S P E A K
                </h1>
                {/*end::Title*/}
                {/*begin::Description*/}
                <p className="fw-bold fs-2" style={{ color: '#26196b' }}>
                  Selamat Datang di <br /> Aplikasi SPEAK RUMAH SAKIT <br />
                  (Sistim Pengelolaan Akreditasi LAM-KPRS)
                </p>
                {/* <p>
                  Sistim ini digunakan untuk mengelola semua Data Akreditasi
                  Rumah Sakit dan Surveior yang dilakukan oleh LAM-KPRS.{' '}
                </p> */}
                {/*end::Description*/}
              </div>
              {/*end::Content*/}

              {/*end::Illustration*/}
            </div>
            {/*end::Wrapper*/}
          </div>
          {/*end::Aside*/}

          {/* Bagian kanan - Form Login */}
          <div
            className="col-md-6 d-flex align-items-center justify-content-center"
            style={{
              backgroundImage: `url(${background})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              minHeight: '100vh', // supaya penuh layar
            }}
          >
            <div className="w-lg-500px bg-body rounded shadow-sm p-10 p-lg-15 mx-auto">
              {/*begin::Heading*/}
              <div className="text-center mb-5">
                {/*begin::Title*/}
                <h1
                  className="fw-bolder fs-2qx pb-2 pb-md-2"
                  style={{ color: '#26196b' }}
                >
                  LOGIN
                </h1>

                {/* <h5 className="mb-3">
                  <i style={{ color: '#26196b' }}>Versi</i>
                </h5>
                <h1 className="mb-3" style={{ color: '#26196b' }}>
                  RUMAH SAKIT
                </h1> */}
                {/*end::Title*/}
              </div>
              {/*begin::Heading*/}
              {/*begin::Input group*/}
              <div className="fv-row mb-5">
                {/*begin::Label*/}
                <label className="form-label fs-6 fw-bolder text-dark">
                  Username
                </label>
                {/*end::Label*/}
                {/*begin::Input*/}
                <input
                  className="form-control form-control-lg form-control-solid"
                  type="text"
                  name="email"
                  autoComplete="off"
                  onChange={(e) => setusername(e.target.value)}
                  value={username}
                />
                {/*end::Input*/}
              </div>
              {/*end::Input group*/}
              {/*begin::Input group*/}
              <div className="fv-row mb-5">
                {/*begin::Wrapper*/}
                <div className="d-flex flex-stack mb-2">
                  {/*begin::Label*/}
                  <label className="form-label fw-bolder text-dark fs-6 mb-0">
                    Password
                  </label>
                  {/*end::Label*/}
                </div>
                {/*end::Wrapper*/}
                {/*begin::Input*/}
                <input
                  className="form-control form-control-lg form-control-solid"
                  type="password"
                  name="password"
                  autoComplete="off"
                  onChange={(e) => setpassword(e.target.value)}
                  value={password}
                />
                <div className="text-end mb-5">
                  <small
                    style={{ cursor: "pointer", color: "#26196b" }}
                    onClick={() => setShowModal(true)}
                  >
                    Lupa Password?
                  </small>
                </div>
                {/*end::Input*/}
              </div>
              {/*end::Input group*/}
              {/*begin::Actions*/}
              <div className="text-center">
                {/*begin::Submit button*/}
                <button
                  onClick={() => handleLogin()}
                  type="button"
                  id="kt_sign_in_submit"
                  className="btn btn-sm btn-primary w-100 mb-3"
                  disabled={disabled}
                >
                  <IconLogin stroke={2} />
                  &nbsp;
                  {loading === true ? 'Mohon Tunggu..' : 'Login'}
                </button>
                {/*end::Submit button*/}
                <small className="align-items-center">
                  Version: {APP_VERSION}
                </small>
              </div>
              {/*end::Actions*/}
            </div>
          </div>
        </div>
      </div>

      <VersionInfoButton />

      {showModal && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Reset Password</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>

              <div className="modal-body">
                <label className="form-label">Username</label>
                <input
                  type="text"
                  className="form-control"
                  value={resetUsername}
                  onChange={(e) => setResetUsername(e.target.value)}
                />
                <small className="text-muted">
                  Password akan direset ke: <b>Qwerty123#</b>
                </small>
              </div>

              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setShowModal(false)}
                >
                  Batal
                </button>
                <button
                  className="btn btn-primary"
                  onClick={handleResetPassword}
                  disabled={loadingReset}
                >
                  {loadingReset ? "Memproses..." : "Reset Password"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default LoginPage;
